import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fcfbe97e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container bg-white" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, "\n      理解度テスト\n    ", -1))
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "large-title" }, "\n        CHECK\n      ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, "\n        お仕事に申し込む前にキャンセルルールについて簡単なテストをクリアしてください。テストは3問です。\n      ", -1))
const _hoisted_6 = { class: "image" }
const _hoisted_7 = { class: "footer bg-white" }

import { computed } from "vue";
import { useRoute } from "vue-router";
import CaikumaRunning from "@/assets/svg/UnderstandingTest/CaikumaRunning.svg?component";
import AppButton from "@/components/atoms/button/AppButton.vue";
import { useCustomRouter } from "@/utils/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'UnderstandingTestStart',
  setup(__props) {

const route = useRoute();
const { replaceIgnoreError } = useCustomRouter();

const orderId = computed(() => Number(route.params["orderId"]));
const workTimeOptionId = computed(() =>
  Number(route.params["workTimeOptionId"])
);

async function onClickNext() {
  await replaceIgnoreError({
    name: "OrdersUnderstandingTestQuestion",
    params: {
      orderId: orderId.value.toString(),
      workTimeOptionId: workTimeOptionId.value.toString()
    }
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createTextVNode(),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createTextVNode(),
      _hoisted_5,
      _createTextVNode(),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(CaikumaRunning))
      ])
    ]),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(AppButton, {
        block: "",
        class: "button",
        onClick: onClickNext
      }, {
        default: _withCtx(() => [
          _createTextVNode("テストへ進む")
        ], undefined, true),
        _: 1
      })
    ])
  ]))
}
}

})